
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/details",
      function () {
        return require("private-next-pages/checkout/details.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/details"])
      });
    }
  